import { lazy } from 'react';
import { authRoles } from 'app/auth';
import { PlusFeatureGate } from 'app/shared-components/PlusPaywall';
import ManagedRepeatsPaywall from './components/ManagedRepeatsPaywall';

const ManagedRepeatsPage = lazy(() => import('./ManagedRepeatsPage'));
const AddNewDMRPatientPage = lazy(() => import('./AddNewDMRPatientPage'));
const DMRFormPage = lazy(() => import('./DMRFormPage'));

function gated(page) {
  return (
    <PlusFeatureGate
      feature="digitalManagedRepeats"
      title="Digital Managed Repeats"
      paywall={<ManagedRepeatsPaywall />}
    >
      {page}
    </PlusFeatureGate>
  );
}

const formPageSettings = {
  layout: {
    config: {
      healtheraHeader: {
        display: true,
        options: {
          // Mounted but hidden so pharmacy selection still initialises on direct page load
          pharmacySelector: true,
          pharmacySelectorHidden: true,
        },
      },
    },
  },
};

const ManagedRepeatsConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'managed-repeats',
      element: gated(<ManagedRepeatsPage />),
    },
    {
      path: 'managed-repeats/active-dmr',
      element: gated(<ManagedRepeatsPage />),
    },
    {
      path: 'managed-repeats/create-dmr',
      element: gated(<ManagedRepeatsPage />),
    },
    {
      path: 'managed-repeats/active-dmr/edit',
      element: gated(<DMRFormPage />),
      settings: formPageSettings,
    },
    {
      path: 'managed-repeats/create-dmr/create',
      element: gated(<DMRFormPage />),
      settings: formPageSettings,
    },
    {
      path: 'managed-repeats/add-patient',
      element: gated(<ManagedRepeatsPage />),
    },
    {
      path: 'managed-repeats/add-patient/unused-invites',
      element: gated(<ManagedRepeatsPage />),
    },
    {
      path: 'managed-repeats/add-patient/inactive-patients',
      element: gated(<ManagedRepeatsPage />),
    },
    {
      path: 'managed-repeats/add-patient/unassigned-patients',
      element: gated(<ManagedRepeatsPage />),
    },
    {
      path: 'managed-repeats/add-patient/create',
      element: gated(<AddNewDMRPatientPage />),
      settings: formPageSettings,
    },
  ],
};

export default ManagedRepeatsConfig;
